module.exports = __webpack_public_path__ + "img/meet-download-icon@3x.svg";